import Mark from 'mark.js/dist/jquery.mark.min';
import {delay} from './helpers';

const finderContainer = $_vikon('#vikon-finder-container');
const vikonFinderIconContainer = $_vikon('#vikon-finder-icon-container');
const vikonContent = $_vikon('.vikon-content');
let vikonDefaultSectionHtml;
const vikonFinderFormInput = $_vikon('#vikon-finder-form-input');
let countFind = 0;
let currentFind = 0;

vikonFinderIconContainer.on('click', () => {
    if (finderContainer.hasClass('finder-active')) {
        resetFindForm();
    } else {
        finderContainer.addClass('finder-active');
    }
});
$_vikon('#vikon-finder-form-close').on('click', () => {
    vikonFinderFormInput.val('');
    finderContainer.removeClass('finder-active');
});

vikonFinderFormInput.on('keyup', function () {
    doSearch($_vikon(this).val());
});

$_vikon('#vikon-finder-form-close').on('click', () => {
    doSearch('');
});

$_vikon('#vikon-finder-form-prev').on('click', () => {
    currentFind--;
    findGoTo();
});

$_vikon('#vikon-finder-form-next').on('click', () => {
    currentFind++;
    findGoTo();
});

function findGoTo() {
    if (countFind > 0) {
        $_vikon('mark.vikon-finder.vikon-finder-current').removeClass('vikon-finder-current');
        const findWord = $_vikon(`mark.vikon-finder:visible:eq(${currentFind})`);
        if (findWord.length !== 0) {
            findWord.addClass('vikon-finder-current');
            animation(findWord);
        } else {
            currentFind = 0;
            findGoTo();
        }
    }
}

function doSearch(term) {
    delay(() => {
        const instance = new Mark(document.getElementById('vikon-content'));
        term = term.trim();
        countFind = 0;
        currentFind = 0;
        instance.unmark({
            className: 'vikon-finder',
        });

        if (term) {
            const searchRegex = new RegExp(term, 'gim');
            instance.markRegExp(searchRegex, {
                className: 'vikon-finder',
            });

            countFind = vikonContent.find('mark.vikon-finder:visible').length;
            if (countFind > 0) {
                vikonFinderFormInput.parent().removeClass('has-error').addClass('has-success');
                findGoTo();
            } else {
                vikonFinderFormInput.parent().removeClass('has-success').addClass('has-error');
            }
        } else {
            vikonFinderFormInput.parent().removeClass('has-success').removeClass('has-error');
        }
    }, 500);
}

function animation(element) {
    $_vikon('body, html, #vikon-content-abitur').animate({scrollTop: element.offset().top - 200}, 200);
}

function resetFindForm() {
    finderContainer.removeClass('finder-active');
    vikonFinderFormInput.val('');
    doSearch('');
}

$_vikon(document).on('shown.bs.tab', 'a[data-toggle="tab"]', (e) => {
    resetFindForm();
});
